import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IPerakendeSatislarListesiOzelcopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPerakendeSatislarListesiOzelcopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetStoreInfo: any[];
  GetStoreInfo_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  GetSalesDetailList: any[];
  GetSalesDetailList_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp324396Visible: "visible" | "hidden";
  isComp147435Enabled: "enabled" | "disabled";
  isComp431562Enabled: "enabled" | "disabled";
  isComp754486Enabled: "enabled" | "disabled";
}

export class PerakendeSatislarListesiOzelcopy_ScreenBase extends React.PureComponent<
  IPerakendeSatislarListesiOzelcopy_ScreenProps,
  any
> {
  perakendesatislarlistesiozelcopy_633300_value_kuikaSelectBoxRef: React.RefObject<any>;
  perakendesatislarlistesiozelcopy_965256_value_kuikaSelectBoxRef: React.RefObject<any>;
  perakendesatislarlistesiozelcopy_905610_value_kuikaDateRef: React.RefObject<any>;
  perakendesatislarlistesiozelcopy_836291_value_kuikaDateRef: React.RefObject<any>;
  perakendesatislarlistesiozelcopy_147435_value_kuikaTableRef: React.RefObject<any>;
  perakendesatislarlistesiozelcopy_431562_value_kuikaTableRef: React.RefObject<any>;
  perakendesatislarlistesiozelcopy_754486_value_kuikaTableRef: React.RefObject<any>;
  perakendesatislarlistesiozelcopy_210117_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "2dd37546-8720-49dd-ac91-bb65bc9a2be7",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 976357, PropertyName: "label", Value: "Profil" },
        { Id: 446097, PropertyName: "label", Value: "Çıkış Yap" },
        {
          Id: 342102,
          PropertyName: "value",
          Value: "Perakende Satışlar Listesi",
        },
        { Id: 633300, PropertyName: "placeholder", Value: "Mağaza" },
        { Id: 965256, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 905610, PropertyName: "placeholder", Value: "Başlangıç Tarihi" },
        { Id: 836291, PropertyName: "placeholder", Value: "Bitiş Tarihi" },
        { Id: 758630, PropertyName: "label", Value: "Filtrele" },
        { Id: 688516, PropertyName: "label", Value: "Temizle" },
        {
          Id: 147435,
          PropertyName: "nodatafoundmessage",
          Value: "Veri bulunamadı",
        },
        { Id: 478975, PropertyName: "title", Value: "Title" },
        { Id: 627540, PropertyName: "value", Value: "[datafield:invoicedate]" },
        {
          Id: 431058,
          PropertyName: "value",
          Value: "[datafield:invoicenumberretailsale]",
        },
        {
          Id: 832578,
          PropertyName: "value",
          Value: "[datafield:retailcustomercode]",
        },
        {
          Id: 611319,
          PropertyName: "value",
          Value: "[datafield:firstlastname]",
        },
        {
          Id: 431562,
          PropertyName: "nodatafoundmessage",
          Value: "Ürün Bilgisi Bulunamadı",
        },
        { Id: 189733, PropertyName: "title", Value: "Title" },
        {
          Id: 754486,
          PropertyName: "nodatafoundmessage",
          Value: "Ödeme Bilgisi Bulunamadı",
        },
        { Id: 514055, PropertyName: "title", Value: "Title" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.perakendesatislarlistesiozelcopy_633300_value_kuikaSelectBoxRef =
      React.createRef();
    this.perakendesatislarlistesiozelcopy_965256_value_kuikaSelectBoxRef =
      React.createRef();
    this.perakendesatislarlistesiozelcopy_905610_value_kuikaDateRef =
      React.createRef();
    this.perakendesatislarlistesiozelcopy_836291_value_kuikaDateRef =
      React.createRef();
    this.perakendesatislarlistesiozelcopy_147435_value_kuikaTableRef =
      React.createRef();
    this.perakendesatislarlistesiozelcopy_431562_value_kuikaTableRef =
      React.createRef();
    this.perakendesatislarlistesiozelcopy_754486_value_kuikaTableRef =
      React.createRef();
    this.perakendesatislarlistesiozelcopy_210117_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetStoreInfo: [],
      GetImage: [],
      GetSalesDetailList: [],
      SetValueOf: "",
      dataSource_965256: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son  6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "İki Tarih Arası Filtreleme" },
      ],
      isComp324396Visible: "hidden",
      isComp147435Enabled: "disabled",
      isComp431562Enabled: "disabled",
      isComp754486Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "perakendesatislarlistesiozelcopy",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.PerakendeSatislarListesiOzelcopyPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "perakendesatislarlistesiozelcopy",
      ""
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "perakendesatislarlistesiozelcopy",
      ""
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.PerakendeSatislarListesiOzelcopyPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  PerakendeSatislarListesiOzelcopyPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      storeCode_2: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_2: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_2: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PerakendeSatislarListesiOzelcopy/PerakendeSatislarListesiOzelcopyPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStoreInfo = result?.data.getStoreInfo;

    formVars.perakendesatislarlistesiozelcopy_633300_options =
      stateVars.GetStoreInfo;
    stateVars.GetImage = result?.data.getImage;
    formVars.perakendesatislarlistesiozelcopy_521690_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetImage !== undefined
          ? stateVars.GetImage?.length > 0
            ? stateVars.GetImage[0].photo
            : null
          : this.state.GetImage?.length > 0
          ? this.state.GetImage[0].photo
          : null
      );
    stateVars.GetSalesDetailList = result?.data.getSalesDetailList;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PerakendeSatislarListesiOzelcopyPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.perakendesatislarlistesiozelcopy_521690_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetImage !== undefined
          ? stateVars.GetImage?.length > 0
            ? stateVars.GetImage[0].photo
            : null
          : this.state.GetImage?.length > 0
          ? this.state.GetImage[0].photo
          : null
      );

    stateVars.dataSource_633300 =
      stateVars.GetStoreInfo ?? this.state.GetStoreInfo;
    stateVars.dataSource_633300 =
      stateVars.GetStoreInfo ?? this.state.GetStoreInfo;
    stateVars.isComp324396Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_147435 =
      stateVars.GetSalesDetailList ?? this.state.GetSalesDetailList;

    formVars.perakendesatislarlistesiozelcopy_210117_total =
      ReactSystemFunctions.value(
        this,
        stateVars.GetSalesDetailList !== undefined
          ? stateVars.GetSalesDetailList?.length > 0
            ? stateVars.GetSalesDetailList[0].totalFaturaSayisi
            : null
          : this.state.GetSalesDetailList?.length > 0
          ? this.state.GetSalesDetailList[0].totalFaturaSayisi
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_891895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PerakendeSatislarListesiOzelcopy",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "488099",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_976357_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PerakendeSatislarListesiOzelcopy",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_446097_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_633300_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "PerakendeSatislarListesiOzelcopy/PerakendeSatislarListesiOzelcopyComponent_633300_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetSalesDetailList = result?.data.getSalesDetailList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_633300_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "PerakendeSatislarListesiOzelcopy/PerakendeSatislarListesiOzelcopyComponent_633300_onChange1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetSalesDetailList = result?.data.getSalesDetailList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_633300_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "perakendesatislarlistesiozelcopy_210117_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_633300_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "7"
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_633300_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "7"
      )
    ) {
      stateVars.dataSource_147435 =
        stateVars.GetSalesDetailList ?? this.state.GetSalesDetailList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_633300_onChange5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_633300_onChange5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "7"
      )
    ) {
      formVars.perakendesatislarlistesiozelcopy_210117_total =
        ReactSystemFunctions.value(
          this,
          stateVars.GetSalesDetailList !== undefined
            ? stateVars.GetSalesDetailList?.length > 0
              ? stateVars.GetSalesDetailList[0].totalFaturaSayisi
              : null
            : this.state.GetSalesDetailList?.length > 0
            ? this.state.GetSalesDetailList[0].totalFaturaSayisi
            : null
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_965256_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "PerakendeSatislarListesiOzelcopy/PerakendeSatislarListesiOzelcopyComponent_965256_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetSalesDetailList = result?.data.getSalesDetailList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_965256_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "7"
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "perakendesatislarlistesiozelcopy_210117_value",
          "string"
        ),
        1,
        ReactSystemFunctions.convertToTypeByName("current", "string"),
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_965256_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp324396Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "7"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_965256_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "7"
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_965256_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "7"
      )
    ) {
      stateVars.dataSource_147435 =
        stateVars.GetSalesDetailList ?? this.state.GetSalesDetailList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PerakendeSatislarListesiOzelcopyComponent_965256_onChange5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_965256_onChange5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "7"
      )
    ) {
      formVars.perakendesatislarlistesiozelcopy_210117_total =
        ReactSystemFunctions.value(
          this,
          stateVars.GetSalesDetailList !== undefined
            ? stateVars.GetSalesDetailList?.length > 0
              ? stateVars.GetSalesDetailList[0].totalFaturaSayisi
              : null
            : this.state.GetSalesDetailList?.length > 0
            ? this.state.GetSalesDetailList[0].totalFaturaSayisi
            : null
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_758630_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PerakendeSatislarListesiOzelcopy/PerakendeSatislarListesiOzelcopyComponent_758630_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSalesDetailList = result?.data.getSalesDetailList;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PerakendeSatislarListesiOzelcopyComponent_758630_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_758630_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "perakendesatislarlistesiozelcopy_210117_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_147435 =
      stateVars.GetSalesDetailList ?? this.state.GetSalesDetailList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_688516_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "perakendesatislarlistesiozelcopy_633300_value",
        "string"
      ),
      "",
      null,
      "StoreCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "perakendesatislarlistesiozelcopy_965256_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("1", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "perakendesatislarlistesiozelcopy_905610_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "perakendesatislarlistesiozelcopy_836291_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "perakendesatislarlistesiozelcopy_210117_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PerakendeSatislarListesiOzelcopyComponent_688516_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_688516_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_210117_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PerakendeSatislarListesiOzelcopy/PerakendeSatislarListesiOzelcopyComponent_688516_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSalesDetailList = result?.data.getSalesDetailList;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PerakendeSatislarListesiOzelcopyComponent_688516_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_688516_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_147435 =
      stateVars.GetSalesDetailList ?? this.state.GetSalesDetailList;
    formVars.perakendesatislarlistesiozelcopy_210117_total =
      ReactSystemFunctions.value(
        this,
        stateVars.GetSalesDetailList !== undefined
          ? stateVars.GetSalesDetailList?.length > 0
            ? stateVars.GetSalesDetailList[0].totalFaturaSayisi
            : null
          : this.state.GetSalesDetailList?.length > 0
          ? this.state.GetSalesDetailList[0].totalFaturaSayisi
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_210117_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "perakendesatislarlistesiozelcopy_210117_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PerakendeSatislarListesiOzelcopy/PerakendeSatislarListesiOzelcopyComponent_210117_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSalesDetailList = result?.data.getSalesDetailList;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PerakendeSatislarListesiOzelcopyComponent_210117_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PerakendeSatislarListesiOzelcopyComponent_210117_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_147435 =
      stateVars.GetSalesDetailList ?? this.state.GetSalesDetailList;
    formVars.perakendesatislarlistesiozelcopy_210117_total =
      ReactSystemFunctions.value(
        this,
        stateVars.GetSalesDetailList !== undefined
          ? stateVars.GetSalesDetailList?.length > 0
            ? stateVars.GetSalesDetailList[0].totalFaturaSayisi
            : null
          : this.state.GetSalesDetailList?.length > 0
          ? this.state.GetSalesDetailList[0].totalFaturaSayisi
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_914955_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_966582_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_163937_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_22538_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_546844_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_558069_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PerakendeSatislarListesiOzelcopyComponent_212460_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [488099] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.PerakendeSatislarListesiOzelcopyPageInit();
    }
  }
}
